import Http from '../index.js'
import Model from '../Model.js'

class Wallets extends Model {
  constructor() {
    super('/wallets/')
  }

  list(filter = '') {
    return Http.get(`${this.model}list_wallets/${filter}`)
  }

  createWallet(payload) {
    return Http.post(`${this.model}create_wallet/`, payload)
  }

  updateWallet(id, payload) {
    return Http.patch(`${this.model}${id}/update_wallet/`, payload)
  }

  updateWalletStatus(id, active) {
    return Http.post(`${this.model}${id}/update_wallet_status/`, { active })
  }

  delete(payload) {
    return Http.post(`${this.model}delete_wallet/`, { wallet: payload })
  }
}

export default new Wallets()
